<div class="bluesage-card-fields">
    <!-- BlueSage serves this page. No card input is ever drawn by this
         application, and the Passage script never loads in this document. -->
    <iframe
        *ngIf="safeUrl; else noForm"
        [src]="safeUrl"
        [style.height.px]="heightPx"
        title="Card details"
        allow="payment"
        referrerpolicy="no-referrer"
    ></iframe>

    <ng-template #noForm>
        <p class="p-text-secondary">
            The card form could not be opened. Close this and try again.
        </p>
    </ng-template>
</div>
